const setRefs = (target) => (name) => (element) => {
  target.refsMap[name] = element;
};

export default setRefs;
